import React from 'react';
import CrmTimelineListPage from './components/CrmTimelineListPage';

export default function HistoryPage() {
  return (
    <CrmTimelineListPage
      pageKey="historyPage"
      historyOnly
      showDealAmount
    />
  );
}
